// src/services/ApiClient.js
import axios from 'axios';

// Temel API adresi. .env(.development/.production) içindeki REACT_APP_API_URL
// tanımlıysa onu kullanır, yoksa canlı adrese düşer.
const baseURL = process.env.REACT_APP_API_URL || 'https://api.utkanesim.com/';

const apiClient = axios.create({
  baseURL: baseURL,
  timeout: 20000, // İstekler için 10 saniye zaman aşımı (isteğe bağlı)
  headers: {
    'Content-Type': 'application/json', // Varsayılan olarak JSON gönderdiğimizi belirtelim
    'Accept': 'application/json',      // Varsayılan olarak JSON kabul ettiğimizi belirtelim
  },
});

// --- İstek (Request) Interceptor ---
// Her istek gönderilmeden hemen önce çalışır.
apiClient.interceptors.request.use(
  (config) => {
    // AuthContext'ten veya localStorage/sessionStorage'dan token'ı al
    // ÖNEMLİ: 'authToken' anahtarını kendi kullandığınız anahtarla değiştirin!
    const token = localStorage.getItem('authToken'); // Veya sessionStorage

    // Eğer token varsa, Authorization header'ını ekles
    if (token) {
      // Bearer şeması yaygındır, API'nizin beklediği şemayı kullanın
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config; // Değiştirilmiş veya orijinal config'i döndür
  },
  (error) => {
    // İstek yapılandırmasında bir hata olursa burası çalışır
    console.error("Request Interceptor Error:", error);
    return Promise.reject(error); // Hatanın devam etmesini sağla
  }
);

// --- Yanıt (Response) Interceptor ---
// API'den bir yanıt alındığında (başarılı veya hatalı) çalışır.
apiClient.interceptors.response.use(
  (response) => {
    // Başarılı yanıtlar (2xx status code) için doğrudan yanıtı döndür
    return response;
  },
  (error) => {
    // Hatalı yanıtlar için burası çalışır
    console.error("Response Interceptor Error:", error.response || error.message);

    // Özel hata yönetimi (Örnek: 401 Unauthorized)
    if (error.response && error.response.status === 401) {
      console.warn("Unauthorized (401)! Token geçersiz veya süresi dolmuş olabilir.");
      // Kullanıcıyı otomatik olarak logout yap ve login sayfasına yönlendir
      // ÖNEMLİ: Bu kısım projenizin yapısına göre değişir.
      // - AuthContext kullanıyorsanız, context üzerinden logout fonksiyonunu çağırın.
      // - localStorage kullanıyorsanız, token'ı silin.

      // 1. Token'ı temizle (kullandığınız yönteme göre)
      localStorage.removeItem('authToken'); // Veya sessionStorage.removeItem

      // 2. Kullanıcıyı Login sayfasına yönlendir (React Router'ı doğrudan burada kullanamayız)
      //    En basit yöntem: Sayfayı yeniden yükleyerek login'e yönlendirme.
      //    ProtectedRoute zaten giriş yapılmamışsa login'e yönlendirecektir.
      if (!window.location.pathname.includes('/login')) {
        // Eğer zaten login sayfasında değilsek yönlendir, sonsuz döngüye girmemek için
        window.location.href = '/login?sessionExpired=true'; // Sayfayı yenileyerek yönlendir
        // Not: Daha sofistike yöntemler (event emitter, context ile state güncelleme) de kullanılabilir
        //      ancak bu genellikle yeterli olur.
      }

      // 401 hatasını işlediğimiz için artık devam etmesine gerek yok gibi görünebilir,
      // ancak bazı durumlarda çağıran kodun da hatayı bilmesi gerekebilir.
      // Şimdilik hatanın devam etmesini sağlayalım.
      return Promise.reject(error);

    } else if (error.response && error.response.status === 403) {
      console.warn("Forbidden (403)! Kullanıcının bu işlem için yetkisi yok.");
      // İsteğe bağlı olarak kullanıcıya bir mesaj gösterebilirsiniz.
    }
    // Diğer hatalar (5xx, 404 vb.) veya network hataları için
    // hatanın devam etmesini sağlıyoruz ki, isteği yapan .catch() bloğu çalışabilsin.
    return Promise.reject(error);
  }
);

export default apiClient;